import React, { useRef, useEffect } from "react";
import JsBarcode from "jsbarcode";
const BarcodeGenerator = ({value}) => {

   if(!value || value ==="") value=0 

  useEffect(() => {
    new JsBarcode(".barcode"+value, value , {
        format: 'CODE128',
        renderer: 'svg',
        width: 2,
        height: 100,
        displayValue: true,
        fontOptions: '',
        font: 'monospace',
        textAlign: 'center',
        textPosition: 'bottom',
        textMargin: 2,
        fontSize: 20,
        background: '#ffffff',
        lineColor: '#000000',
        margin: 10,
      });
  });
  return <svg className={"barcode"+value} />;
};

export default BarcodeGenerator;
